import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { BarChart3, BookOpen, Brain, Clock, Target, TrendingUp } from "lucide-react";

const features = [
  {
    icon: BookOpen,
    title: "Decision Tracking",
    description: "Record your decisions with rating, context, reasoning, and expected outcomes in a structured format."
  },
  {
    icon: BarChart3,
    title: "Outcome Analysis",
    description: "Compare predicted vs actual results over time to identify patterns in your decision-making process."
  },
  {
    icon: Brain,
    title: "Bias Detection",
    description: "Record emotions at decision making time to recognize cognitive biases and emotional influences that may affect your judgment."
  },
  {
    icon: TrendingUp,
    title: "Progress Insights",
    description: "Track your decision-making improvement over time with detailed analytics and trends."
  },
  {
    icon: Target,
    title: "Goal Alignment",
    description: "Ensure your decisions align with your long-term goals and values through structured tags and categorization."
  },
  {
    icon: Clock,
    title: "Review Reminders",
    description: "Get prompted to review past decisions at the right time to capture accurate outcomes."
  }
];

interface FeaturesProps {
  onSignUp?: () => void;
}

export function Features({ onSignUp }: FeaturesProps) {
  console.log('Features onSignUp:', onSignUp); // Use the prop to avoid TS error
  return (
    <section id="features" className="py-20 bg-muted/30">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="mb-4">
            Everything You Need for Better Decision Making
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Our thoughtfully designed tools help you build a systematic approach to decision making, 
            learning from both successes and mistakes.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Card key={index} className="border-0 shadow-sm">
              <CardHeader>
                <div className="p-2 bg-primary/10 rounded-lg w-fit mb-4">
                  <feature.icon className="h-6 w-6 text-primary" />
                </div>
                <CardTitle className="text-lg">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="leading-relaxed">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}